import { render } from "./ModuleProgressBar.vue?vue&type=template&id=2e2305ea&scoped=true&ts=true"
import script from "./ModuleProgressBar.vue?vue&type=script&lang=ts"
export * from "./ModuleProgressBar.vue?vue&type=script&lang=ts"

import "./ModuleProgressBar.vue?vue&type=style&index=0&id=2e2305ea&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2305ea"]])

export default __exports__